export default __webpack_public_path__ + "images/icon-image-toggle.svg";